import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../../redux/store";
import axiosInstance from "../../../api/axiosInstance";
import endpoints from "../../../api/endpoints";

export interface CAData {
  NumeroClient: string;
  RaisonSociale: string;
  MOIS: string;
  ANNEE: string;
  CA: string;
  societe: string;
}

interface ClientInfo {
  NumeroClient: string;
  RaisonSociale: string;
  NumeroRepresentant: string;
  NomRepresentant: string;
  DateCreationClient: string;
  Assurance: string;
  Etat: string;
  SituationEnCommande: string;
  SituationEnLivraison: string;
  SituationLivraisonNonFacture: string;
  SituationFactureNonComptabilise: string;
  SituationPortefeuille: string;
  SoldeComptable: string;
  EncoursAutorise: string;
  SoldeClient: string;
  CAdata: CAData[];
}

interface ClientState {
  clientInfo: ClientInfo | null;
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
}

const initialState: ClientState = {
  clientInfo: null,
  status: "idle",
  error: null,
};

interface InputBody {
  NumeroClient: string;
}

export const fetchClientData = createAsyncThunk(
  "client/fetchClientData",
  async (_, { getState, rejectWithValue }) => {
    const state = getState() as RootState;
    const language = state.languageSlice?.language || "fr";
    const token = state.authSlice.token;

    try {
      const response = await axiosInstance.get(
        endpoints.infosClient.infosClientDetail,
        {
          headers: {
            "Accept-Language": language,
            "Authorization": `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error: any) {
      console.error("Erreur lors de la récupération des données client:", error);
      if (error.response) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const fetchClientDataRepresentant = createAsyncThunk(
  "client/fetchClientDataRepresentant",
  async (clientData: InputBody, { getState, rejectWithValue }) => {
    try {
      const state = getState() as RootState;


  

      const response = await axiosInstance.post(
        endpoints.infosClient.represenatantClientDetails ,
        clientData
      );
      return response.data;
    } catch (error: any) {
      console.error("Erreur lors de la récupération des données du client représentant:", error);
      if (error.response) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const clientSlice = createSlice({
  name: "client",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchClientData.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchClientData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.clientInfo = action.payload;
      })
      .addCase(fetchClientData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload ? (action.payload as string) : action.error.message || "Quelque chose a mal tourné";
      })
      .addCase(fetchClientDataRepresentant.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchClientDataRepresentant.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.clientInfo = action.payload;
      })
      .addCase(fetchClientDataRepresentant.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload ? (action.payload as string) : action.error.message || "Quelque chose a mal tourné";
      });
  },
});

export default clientSlice.reducer;
